import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { getUserGroupsActionHandler } from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import classes from "./GroupTopicDetails.module.scss";
import { addGroupTopic } from "../../../../../utils/mainTabs/organize/addGroupTopic";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";
import { FormattedMessage, injectIntl } from "react-intl";
import Loader from "../../../../../components/Common/Loader/Loader";

export const groupTopicSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required!"),
  // UserGroupDetails: yup
  //   .array(
  //     yup.object().shape({
  //       Name: yup.string(),
  //       UserGroupId: yup.number(),
  //     })
  //   )
  //   .min(1, "Tag is required!"),
  UserGroupDetails: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        UserGroupId: yup.number(),
      })
    )
    .min(1, "Select at least One User Group to proceed")
    .max(20, "Maximum 20 User Groups allowed"),
  otherwise: yup.array(
    yup.object().shape({
      Name: yup.string(),
      UserGroupId: yup.number(),
    })
  ),

  description: yup.string().required("Description is required!"),
  thumbnailImageFile: yup
    .mixed()
    .test("thumbnailImageFile", "Thumbnail Image is required!", (value) => {
      if (value?.length < 1) return false;
      return true;
    }),
  // thumbnailImageFile: yup
  //   .mixed()
  //   .transform((v) => (!v ? undefined : v))
  //   .required("Thumbnail Image is required!"),
});

const GroupTopicDetails = ({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParams = useParams();
  const [userGroupList, setUserGroupList] = useState([]);
  const [removeViewButtonAfterCancel, setRemoveViewButtonAfterCancel] =
    useState(true);
  const [loader, setLoader] = useState(true);
  const [validClassName, setValidClassName] = useState(true);
  const [fileSize, setFileSize] = useState();
  const [topicListLoader, setTopicListLoader] = useState(true);
  // const [filteredUserGroupList, setFilteredUserGroupList] = useState([]);
  const {
    formData,
    setFormData,
    createGroupTopicEditPath,
    tenantName,
    pathType,
    getAllTopics,
  } = useOutletContext();
  // useEffect(() => {
  //   if (userGroupList?.length > 0) {
  //     const updatedUserGroupList = userGroupList?.filter(
  //       (userGroup) => userGroup.isVisible === true
  //     );

  //     console.log(userGroupList, updatedUserGroupList);
  //     setFilteredUserGroupList(updatedUserGroupList);
  //   }
  // }, [userGroupList]);

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(groupTopicSchema),
    defaultValues: useMemo(() => {
      return {
        ...formData.details,
      };
    }),
  });
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    setValue,
    watch,
    trigger,
  } = methods;
  let thumbinalViewBtn = watch("thumbnailImageFile");
  let setUpdatedUserGroups = useCallback(
    (userGroupList) => {
      // setValue("UserGroupDetails", "")
      let selectedTags = [];
      selectedTags = formData?.details?.UserGroupDetails;
      // console.log(selectedTags);
      if (
        // location.pathname.includes(createGroupTopicEditPath) &&
        selectedTags?.length > 0
      ) {
        let updatedUserGroup = userGroupList?.map((userGroup) => {
          let updatedUserGroup = userGroup;
          selectedTags.forEach((tag) => {
            if (userGroup.UserGroupId === tag.UserGroupId) {
              updatedUserGroup = { ...userGroup, checked: true };
            }
          });
          return { ...updatedUserGroup, isVisible: true };
        });
        // debugger;
        setUserGroupList(updatedUserGroup);
        // setFilteredUserGroupList(updatedUserGroup);
        // console.log(updatedUserGroup);
        // debugger;
      } else {
        let updatedUserGroup = userGroupList?.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
        // setFilteredUserGroupList(updatedUserGroup);
      }
    },
    [
      // location.pathname,
      // createGroupTopicEditPath,
      formData?.details?.UserGroupDetails,
    ]
  );

  // useEffect(() => {
  //   dispatch(getUserGroupsActionHandler(setUpdatedUserGroups));
  // }, [dispatch, setUpdatedUserGroups]);

  useEffect(() => {
    dispatch(getUserGroupsActionHandler()).then((data) => {
      setUpdatedUserGroups(data);
    });
  }, [dispatch, setUpdatedUserGroups]);

  const handleCancelImage = useCallback(() => {
    setRemoveViewButtonAfterCancel(false);
    trigger(["ThumbnailImage"]);
  }, [trigger]);
  useEffect(() => {
    setLoader(true);
    reset(() => formData?.details);
  }, [formData?.details]);
  useEffect(() => {
    if (formData?.details?.name) {
      setLoader(false);
    }
  }, [setLoader, formData?.details?.name]);

  let maxSize = 1048576 * 10;
  const fileChange = (event) => {
    event.preventDefault();
    let files = event.target.files[0];
    setFileSize(files.size);
    const accept = ["image/png", "image/jpeg", "image/gif", "image/bmp"];
    if (!accept.includes(files.type)) {
      setValue("thumbnailImageFile", "");
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please select a valid format from [.png, .jpg, .gif, .bmp]"
        )
      );
    } else if (files.size > maxSize) {
      setValue("thumbnailImageFile", "");
      dispatch(
        setErrorHandler(
          errorTypes.FAIL,
          "Max file size should not be greater than 10MB"
        )
      );
    }
  };
  const clearAll = () => {
    reset();
    dispatch(getUserGroupsActionHandler()).then((data) => {
      reset(setUpdatedUserGroups(data));
    });
  };
  const onSubmit = (data) => {
    setFormData((formData) => {
      return {
        ...formData,
        details: {
          ...formData.details,
          ...data,
          tenantId: userGroupList?.[0]?.TenantId,
        },
      };
    });
    navigate(
      `${addGroupTopic.path(location, routerParams, tenantName)}/topicContent`
    );
  };
  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value.trim();
      if (val) {
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setValidClassName(true);
        } else {
          setValidClassName(false);
        }
      } else {
        setValidClassName(true);
      }
    },
    [dispatch, setValidClassName]
  );

  useEffect(() => {
    if (getAllTopics?.length > 1 || getAllTopics?.length === 0) {
      setTopicListLoader(false);
    }
  }, [getAllTopics?.length, setTopicListLoader]);
  
  return (loader && location.pathname.includes(createGroupTopicEditPath)) ||
    topicListLoader ? (
    <Loader page />
  ) : (
    <div className={classes.grpTopicDetailsMain}>
      <FormProvider {...methods}>
        <h1 className={classes.title}>Topic Details</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.topicFormsMain}>
            <div className={classes.topicForms}>
              <div>
                <Input
                  label={<FormattedMessage id="NAME_TEXT" />}
                  name="name"
                  placeholder={"Enter Topic Name"}
                  labelColor="dark"
                  required
                  disabled={location.pathname.includes(
                    createGroupTopicEditPath
                  )}
                  maxLength={100}
                  //error={errors?.name?.message}
                  onChange={handleNameExists}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors?.name?.message ? (
                  <div className={classes.errorMsg}>{errors.name?.message}</div>
                ) : !validClassName ? (
                  <div className={classes.errorMsg}>
                    Only alphanumeric and special characters like ':#@?[]_`| are
                    allowed
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className={classes.userGroupDiv}>
                <Input
                  label={"Add User Group"}
                  name="UserGroupDetails"
                  labelColor="light"
                  type="noSearchTags"
                  fieldName="Name"
                  fieldValue="UserGroupId"
                  placeholder={intl.formatMessage({
                    id: `ANALYTICAL_SEARCH_USER_GROUP`,
                  })}
                  height="3.9"
                  width="24.5"
                  required
                  searchable={true}
                  id={"UserGroupId"}
                  searchTagsList={userGroupList}
                  handleTagList={(tagsList) => {
                    setUserGroupList(tagsList);
                  }}
                  error={errors?.UserGroupDetails?.message}
                />
              </div>
              <Input
                label={<FormattedMessage id="DESCRIPTION_TEXT" />}
                name="description"
                placeholder={"Enter Topic Description..."}
                labelColor="dark"
                required
                maxLength={200}
                error={errors?.description?.message}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className={classes.uploadThumbnailBtn}>
              <Input
                label={<FormattedMessage id="UPLOADIMAGE_TEXT" />}
                name="thumbnailImageFile"
                labelColor="dark"
                type="file"
                required
                disableLabelClick={true}
                hidden={true}
                // error={errors?.thumbnailImageFile?.message}
                accept=".png, .jpg, .gif, .bmp"
                width="21"
                onChange={fileChange}
                handleCancelFileInput={() => handleCancelImage()}
                fileInputView={
                  pathType === "edit" && !(thumbinalViewBtn?.length == "1")
                }
              />
              <div className={classes.infoIcon}>
                <Tooltip
                  direction="right"
                  content={
                    "Format Supported: .png, .jpg, .gif, .bmp"
                    // <FormattedMessage
                    //   id="FORMAT_UPLOAD_INFO"
                    //   values={".png, .jpg, .gif, .bmp"}
                    // />
                  }
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            </div>
            <div className={classes.topicBtns}>
              {/* {!isDirty && (
                <div
                  className={classes.clearAll}
                  onClick={() =>
                    navigate(`${topicManagement.path(tenantName)}`)
                  }
                >
                  <FormattedMessage id="CANCEL_TEXT" />
                </div>
              )} */}
              {isDirty && (
                <div className={classes.clearAll} onClick={clearAll}>
                  <FormattedMessage id="CLEAR_ALL_TXT" />
                </div>
              )}
              <Button
                label="Save & Next"
                type="submit"
                small
                dark
                disabled={
                  !isValid || !validClassName || getAllTopics?.length < 0
                }
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default injectIntl(GroupTopicDetails);
